
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.334 16.667v.833a1.666 1.666 0 01-1.667 1.667H8.334A1.667 1.667 0 016.667 17.5v-.833h6.667z","fill":"#999"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.617 15h6.766c.183-.785.842-1.464 1.358-1.996.18-.186.343-.354.462-.502A6.667 6.667 0 104.795 12.5c.119.15.283.318.464.505.516.531 1.175 1.21 1.358 1.995zM10 3.75c-1.12 0-2.175.552-2.937 1.314C6.302 5.825 5.75 6.882 5.75 8a.75.75 0 101.5 0c0-.63.323-1.324.874-1.875.55-.551 1.245-.875 1.876-.875a.75.75 0 100-1.5z","fill":"#999"}})])
          )
        }
      }
    